module.exports = __webpack_public_path__ + "img/story047.14511ea8.png";